import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'
import { responseDataSchema, successResponseSchema } from '../schema'

const withdrawalSchema = z.object({
  /** Unique identity, e.g. "63564dbbd17bef00019371fb" */
  id: z.string(),
  /** Withdrawal address, e.g. "rNFugeoj3ZN8Wv6xhuLegUBBPXKCyWLRkB" */
  address: z.string(),
  /** Address remark. If there’s no remark, it is empty. When you withdraw from other platforms to the KuCoin, you need to fill in memo(tag). If you do not fill memo (tag), your deposit may not be available, please be cautious., "1919537769" */
  memo: z.string().nullable().optional(),
  /** Currency, e.g. "XRP" */
  currency: z.string(),
  /** The chain of currency, e.g. "xrp" */
  chain: z.string(),
  /** Withdrawal amount, e.g. "20.50000000" */
  amount: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Withdrawal fee, e.g. "0.50000000" */
  fee: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Wallet Txid, e.g. "2C24A6D5B3E7D5B6AA6534025B9B107AC910309A98825BF5581E25BEC94AD83B" */
  walletTxId: z.string(),
  /** Internal withdrawal or not */
  isInner: z.boolean(),
  /** Status, e.g. "SUCCESS" */
  status: z.union([
    z.literal('PROCESSING'),
    z.literal('WALLET_PROCESSING'),
    z.literal('SUCCESS'),
    z.literal('FAILURE'),
  ]),
  /** remark, e.g. "test" */
  remark: z.string().nullable().optional(),
  /** Creation time, e.g. 1666600519000 */
  createdAt: z.number().int(),
  /** Update time, e.g. 1666600549000 */
  updatedAt: z.number().int(),
})

export type Withdrawal = z.infer<typeof withdrawalSchema>

export const withdrawalResponseSchema = successResponseSchema.extend({
  data: responseDataSchema.extend({
    items: z.array(withdrawalSchema),
  }),
})
